import { env } from './env';

export const MEDIA_BUCKET = 'tenant-media';

/** Public URL of an object in the studio media bucket. */
export function mediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  const encoded = path.split('/').map(encodeURIComponent).join('/');
  return `${env.VITE_SUPABASE_URL}/storage/v1/object/public/${MEDIA_BUCKET}/${encoded}`;
}
